import { State } from "common/types/redux";

import {
  AllowedCallTypes,
  CrudConfig,
  makeApiStatesSelectorsFactory
} from "seneca-common/utils/apiStates";

import { coursesQueryCrudStateConfig } from "../consts";
import CoursesQuery from "../models/CoursesQuery";
import { getCoursesQuerySlice } from "./index";

export function makeSelectors(
  getStateSlice: (arg0: any) => CoursesQuery,
  crudStateConfig: CrudConfig
) {
  const getMetaSlice = (state: State) => {
    return getStateSlice(state).meta;
  };

  const makeApiStatesSelectors = makeApiStatesSelectorsFactory(crudStateConfig);

  const {
    hasStarted,
    didSucceed,
    didError,
    getLastFetchedTime,
    hasFinished,
    notSucceededOrStarted
    // @ts-ignore
  } = makeApiStatesSelectors(getMetaSlice)[AllowedCallTypes.FETCH];

  return {
    getFetchCoursesQueryStarted: hasStarted,
    getFetchCoursesQuerySuccess: didSucceed,
    getFetchCoursesQueryError: didError,
    getFetchCoursesQueryLastFetched: getLastFetchedTime,
    coursesQueryHasFinishedFetching: hasFinished,
    coursesQueryNeedsFetching: notSucceededOrStarted
  };
}

export const {
  getFetchCoursesQueryStarted,
  getFetchCoursesQuerySuccess,
  getFetchCoursesQueryError,
  getFetchCoursesQueryLastFetched,
  coursesQueryHasFinishedFetching,
  coursesQueryNeedsFetching
} = makeSelectors(getCoursesQuerySlice, coursesQueryCrudStateConfig);
